import React from 'react'

import { renderFormulas } from '../logic/formatting'
import { normalizeMatchString } from '../logic/productFiltering'

import './HighlightText.scss'

const escapeRegExp = (input: string) =>
  input.replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1')

export const HighlightText = ({
  children,
  highlight,
}: {
  children: string
  highlight?: string[]
}) => {
  // Split text on higlight term, include term itself into parts, ignore case,
  // limiting highlight to 3 characters or more as splitting with less is too heavy
  const regexGroups = highlight
    ?.filter(s => s.trim().length > 2)
    .map(s => `(${escapeRegExp(s)})`)
  const parts = regexGroups?.length
    ? children.split(new RegExp(`${regexGroups.join('|')}`, 'gi'))
    : []
  if (typeof highlight === 'undefined' || parts.length === 0) {
    return <React.Fragment>{renderFormulas(children)}</React.Fragment>
  }
  return (
    <React.Fragment>
      {parts.map((part, index) => (
        <React.Fragment key={index}>
          {highlight.some(
            s => normalizeMatchString(part) === normalizeMatchString(s),
          ) ? (
            <span className="highlightText">{renderFormulas(part)}</span>
          ) : (
            renderFormulas(part)
          )}
        </React.Fragment>
      ))}
    </React.Fragment>
  )
}
